import {
  APP_LOAD,
  REDIRECT,
  LOGOUT,
  LOGIN,
  DASHBOARD_PAGE_UNLOADED,
  LOGIN_PAGE_UNLOADED
} from '../constants/actionTypes';

const defaultState = {
  appName: 'View',
  token: null
};

const checkIfLoggedOut = (token) => {
  var redirectTo = null;
  if(token == null || token === '') {
    redirectTo = "/login"
  }
  return redirectTo
}

export default (state = defaultState, action) => {

  switch (action.type) {
    case APP_LOAD:
      return {
        ...state,
        token: action.token || null,
        appLoaded: true,
        redirectTo: checkIfLoggedOut(action.token),
        configurationId: action.configurationId || null
      };
    case REDIRECT:
      return { ...state, redirectTo: null };
    case LOGOUT:
      return { ...state, redirectTo: '/login', token: null, configurationId: null};
    case LOGIN:
      return {
        ...state,
        redirectTo: action.error ? null : '/',
        token: action.error ? null : action.payload.token,
        configurationId: action.error ? null : action.payload.configurationId
      };
    case DASHBOARD_PAGE_UNLOADED:
    case LOGIN_PAGE_UNLOADED:
      return {
        ...state,
        redirectTo: checkIfLoggedOut(action.token)
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/common.js